import React from "react";
import { Switch } from "@material-ui/core";

const CustomSwitch = ({ checked, size = "medium", onChange }) => {
    return <Switch checked={checked} size={size} onChange={onChange} />;
};

export default CustomSwitch;
